import { getPlatform } from '@tencentcloud/universal-api';
let platform = getPlatform() === 'pc' ? 'web' : 'h5';
function getSocketBaseUrl() {
  const domain = process.env.VUE_APP_SOCKET_URL;
  return domain;
}

export default class WebSocketManager {
  static BASEURL_SOCKET = getSocketBaseUrl();
  
  static HEART_SYBMOL = JSON.stringify({
    messageType: "heartbeat",
    content:`${platform ? platform+'-' : ''}ping`,
  });

  constructor(userID) {
    this.userID = userID;
    this.url = `${WebSocketManager.BASEURL_SOCKET}/websocket/HY_${this.userID}`;
    
    /**
     * 当前尝试次数
     */
    this.retryCount = 0;
    
    /**
     * 最大尝试次数
     */
    this.maxRetries = 7;
    
    /**
     * 初始重连时间（毫秒）
     */
    this.initialDelay = 100;
    
    /**
     * 心跳间隔(毫秒)
     */
    this.heartInterval = 15000;
    
    /**
     * 心跳应答超时时间(毫秒) - 设置为心跳间隔的2倍
     */
    this.heartAckTimeout = 30000;
    
    /**
     * 最大允许的超时次数
     */
    this.maxHeartAckTimeouts = 3;
    
    /**
     * ws实例
     */
    this.ws = null;
    
    /**
     * 心跳计时器
     */
    this.heartTimer = null;
    
    /**
     * 心跳应答超时计时器
     */
    this.heartAckTimer = null;
    
    /**
     * 重连定时器
     */
    this.reconnectTimer = null;
    
    /**
     * 是否手动关闭
     */
    this.isManualClose = false;
    
    /**
     * 是否正在连接中（防止并发连接）
     */
    this.isConnecting = false;

    /**
     * 心跳应答超时次数
     */
    this.heartAckTimeoutCount = 0;
    
    /**
     * 回调函数
     */
    this.onOpenCallback = null;
    this.onCloseCallback = null;
    this.onErrorCallback = null;
    this.onMessageCallback = null;
    
    /**
     * 连续发送失败次数
     */
    this.sendFailCount = 0;
    
    /**
     * 最大允许发送失败次数
     */
    this.maxSendFailCount = 3;

    /**
     * 是否由内部逻辑触发的关闭（心跳失败、发送失败等）
     */
    this.isInternalClose = false;
  }

  /**
   * 建立链接
   */
  connect() {
    // 防止并发连接
    if (this.isConnecting) {
      console.log('正在连接中,跳过本次connect调用');
      return;
    }
    
    // 标记正在连接
    this.isConnecting = true;

    // 清理旧连接
    if (this.ws) {
      try {
        // 先移除事件监听器，防止触发 onclose
        const oldWs = this.ws;
        this.ws = null;
        oldWs.onopen = null;
        oldWs.onclose = null;
        oldWs.onerror = null;
        oldWs.onmessage = null;
        oldWs.close();
      } catch (e) {
        console.error('关闭旧连接失败:', e);
      }
    }
    
    // 重置内部关闭标志
    this.isInternalClose = false;

    console.log(`test--->开始建立WebSocket连接: ${this.url}, 重试次数: ${this.retryCount}`);

    try {
      this.ws = new WebSocket(this.url);
    } catch (error) {
      console.error('创建WebSocket失败:', error);
      this.isConnecting = false;
      this.reconnect();
      return;
    }

    this.ws.onopen = (event) => {
      console.log("test--->WebSocket连接已建立");
      
      // 连接成功,重置所有状态
      this.retryCount = 0;
      this.isConnecting = false;
      this.heartAckTimeoutCount = 0;
      this.sendFailCount = 0;
      this.isInternalClose = false;

      // 清除重连定时器
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }
      
      // 启动心跳
      this.sendHeart();
      
      // 回调
      this.onOpenCallback && this.onOpenCallback(event);
    };

    this.ws.onclose = (event) => {
      console.log(`test--->WebSocket连接已关闭, code: ${event.code}, reason: ${event.reason}, isManualClose: ${this.isManualClose}, isInternalClose: ${this.isInternalClose}`);

      // 释放连接锁
      this.isConnecting = false;

      // 清除所有定时器
      this.clearAllTimers();
      
      // 回调
      this.onCloseCallback && this.onCloseCallback(event);
      
      // 判断是否需要重连：
      // 1. 非手动关闭
      // 2. 满足重连条件的错误码
      if (!this.isManualClose) {
        // 常见的需要重连的错误码
        const shouldReconnect = [1000, 1001, 1006, 1015].includes(event.code);
        
        if (shouldReconnect) {
          console.log('test--->触发自动重连');
          this.reconnect();
        } else {
          console.log(`test--->不重连, code: ${event.code}`);
        }
      } else {
        console.log('test--->手动关闭,不重连');
      }

      // 重置内部关闭标志
      this.isInternalClose = false;
    };

    this.ws.onerror = (error) => {
      console.error("test--->WebSocket Error:", error);
      
      // 清除所有定时器(包括心跳定时器)
      this.clearAllTimers();
      
      // 回调
      this.onErrorCallback && this.onErrorCallback(error);
      
      // 上报错误
      window.$tracker && window.$tracker.send({
        message: '#NOTICE#websocket_error',
        content: JSON.stringify({
          url: this.url,
          error: error,
          retryCount: this.retryCount
        })
      });
      
    };

    this.ws.onmessage = (res) => {
      let obj;
      try {
        obj = JSON.parse(res.data);
      } catch (error) {
        // 非JSON消息,直接忽略
        return;
      }
      
      // 收到心跳应答
      if (obj?.messageType === "heartbeat") {
        
        // 重置超时计数
        this.heartAckTimeoutCount = 0;
        
        // 清除超时计时器
        if (this.heartAckTimer) {
          clearTimeout(this.heartAckTimer);
          this.heartAckTimer = null;
        }
        
        return;
      }
      
      // 处理业务消息
      obj && this.onMessageCallback && this.onMessageCallback(obj);
    };
  }

  /**
   * 关闭链接
   */
  close() {
    console.log('test--->手动关闭WebSocket连接');
    
    this.isManualClose = true;
    this.isConnecting = false;

    // 清除所有定时器
    this.clearAllTimers();
    
    // 关闭连接
    if (this.ws) {
      try {
        if (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING) {
          this.ws.close(1000, '手动关闭');
        }
      } catch (e) {
        console.error('关闭连接失败:', e);
      }
      this.ws = null;
    }
  }

  /**
   * 清除所有定时器
   */
  clearAllTimers() {
    // 清除心跳定时器
    if (this.heartTimer) {
      clearInterval(this.heartTimer);
      this.heartTimer = null;
    }
    
    // 清除心跳应答计时器
    if (this.heartAckTimer) {
      clearTimeout(this.heartAckTimer);
      this.heartAckTimer = null;
    }
    
    // 清除重连定时器
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
  }

  /**
   * 重新连接
   */
  reconnect() {
    // 如果正在连接中或有重连定时器，跳过
    if (this.isConnecting) {
      console.log('test--->正在连接中,跳过重连');
      return;
    }

    if (this.reconnectTimer) {
      console.log('test--->已有重连定时器,跳过');
      return;
    }

    // 如果是手动关闭，不重连
    if (this.isManualClose) {
      console.log('test--->手动关闭状态,不重连');
      return;
    }
    
    // 检查是否达到最大重连次数
    if (this.retryCount >= this.maxRetries) {
      console.error(`test--->达到最大重连次数(${this.maxRetries}),停止重连`);
      
      window.$tracker && window.$tracker.send({
        message: '#NOTICE#websocket_max_retry',
        content: JSON.stringify({
          url: this.url,
          maxRetries: this.maxRetries
        })
      });
      
      return;
    }
    
    // 计算延迟时间(指数退避)
    const delay = this.initialDelay * Math.pow(2, this.retryCount);
    
    console.log(`test--->将在 ${delay}ms 后进行第 ${this.retryCount + 1} 次重连`);
    
    this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null;
      
      window.$tracker && window.$tracker.send({
        message: '#NOTICE#消息提醒-websocket_reconnect-socket重连',
        content: JSON.stringify({
          retryCount: this.retryCount + 1,
          delay: delay
        })
      });
      
      console.log(`test--->开始第 ${this.retryCount + 1} 次重连`);
      
      this.retryCount++;
      this.connect();
    }, delay);
  }

  /**
   * 发送心跳
   */
  sendHeart() {
    // 清除之前的心跳定时器
    if (this.heartTimer) {
      clearInterval(this.heartTimer);
      this.heartTimer = null;
    }
    
    // 清除之前的应答检查定时器
    if (this.heartAckTimer) {
      clearTimeout(this.heartAckTimer);
      this.heartAckTimer = null;
    }

    // 检查连接状态
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
      // console.warn('[Heart] 连接未就绪,无法发送心跳');
      return;
    }
    
    // 立即发送一次心跳
    this.sendHeartbeatPacket();
    
    // 定时发送心跳
    this.heartTimer = setInterval(() => {
      // 双重检查:readyState 和 发送失败次数
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        // 检查是否连续发送失败
        if (this.sendFailCount >= this.maxSendFailCount) {
          // console.error('[Heart] 连续发送失败,停止心跳并触发重连');
          
          // 停止心跳
          if (this.heartTimer) {
            clearInterval(this.heartTimer);
            this.heartTimer = null;
          }
          
          // 清除应答检查
          if (this.heartAckTimer) {
            clearTimeout(this.heartAckTimer);
            this.heartAckTimer = null;
          }
          
          // 重置计数并标记为内部关闭
          this.sendFailCount = 0;
          this.isManualClose = false;
          this.isInternalClose = true;

          // 关闭连接(将由 onclose 触发重连)
          if (this.ws) {
            try {
              this.ws.close();
            } catch (e) {
              console.error('关闭连接失败:', e);
            }
          }
          
          return;
        }
        
        this.sendHeartbeatPacket();
      } else {
        console.warn('[Heart] 连接已断开,停止心跳');
        clearInterval(this.heartTimer);
        this.heartTimer = null;
      }
    }, this.heartInterval);
  }

  /**
   * 发送心跳包并启动应答检查
   */
  sendHeartbeatPacket() {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
      console.warn('[Heart] 连接不可用,跳过心跳');
      this.sendFailCount++;
      return;
    }
    
    try {
      const now = Date.now();
      // this.lastHeartbeatSendTime = now;
      
      // 捕获 send 可能的异常
      this.ws.send(WebSocketManager.HEART_SYBMOL);
      
      // 发送成功,重置失败计数
      this.sendFailCount = 0;
      
      // 启动应答超时检查
      this.sendHeartbeatAndWaitAck();
      
    } catch (error) {
      // 累计发送失败次数
      this.sendFailCount++;
      
      // 上报发送失败
      window.$tracker && window.$tracker.send({
        message: '#ERROR#websocket_send_fail',
        content: JSON.stringify({
          error: error.message,
          failCount: this.sendFailCount
        })
      });
      
      // 如果连续发送失败,立即停止心跳并重连
      if (this.sendFailCount >= this.maxSendFailCount) {
        console.error('[Heart] 连续发送失败超过阈值,停止心跳');
        
        // 清除心跳定时器
        if (this.heartTimer) {
          clearInterval(this.heartTimer);
          this.heartTimer = null;
        }
        
        // 清除应答检查
        if (this.heartAckTimer) {
          clearTimeout(this.heartAckTimer);
          this.heartAckTimer = null;
        }
        
        // 重置计数并标记为内部关闭
        this.sendFailCount = 0;
        this.isManualClose = false;
        this.isInternalClose = true;

        // 关闭连接(将由 onclose 触发重连)
        if (this.ws) {
          try {
            this.ws.close();
          } catch (e) {
            console.error('关闭连接失败:', e);
          }
        }
      }
    }
  }

  /**
   * 设置心跳应答超时检查
   */
  sendHeartbeatAndWaitAck() {
    // 清除之前的超时计时器
    if (this.heartAckTimer) {
      clearTimeout(this.heartAckTimer);
    }
    
    // 设置超时检查
    this.heartAckTimer = setTimeout(() => {
      this.heartAckTimeoutCount++;
      
      console.warn(`[Heart] 心跳应答超时(${this.heartAckTimeout}ms), 累计: ${this.heartAckTimeoutCount}/${this.maxHeartAckTimeouts}`);
      
      window.$tracker && window.$tracker.send({
        message: '#NOTICE#websocket_heartbeat_timeout',
        content: JSON.stringify({
          count: this.heartAckTimeoutCount,
          maxCount: this.maxHeartAckTimeouts,
          url: this.url
        })
      });
      
      // 超过最大允许次数,判定为僵尸连接
      if (this.heartAckTimeoutCount >= this.maxHeartAckTimeouts) {
        console.error('[Heart] 连续多次未收到应答,判定为僵尸连接,触发重连');
        
        // 重置计数
        this.heartAckTimeoutCount = 0;
        this.sendFailCount = 0;
        this.isManualClose = false;
        
        // 清除所有定时器
        this.clearAllTimers();
        
        // 关闭当前连接
        if (this.ws) {
          try {
            this.ws.close();
          } catch (e) {
            console.error('关闭连接失败:', e);
          }
          this.ws = null;
        }
        
        // 释放锁并重连
        this.isConnecting = false;
        this.reconnect();
      }
    }, this.heartAckTimeout);
  }

  /**
   * 监听消息
   */
  onmessage(callback) {
    this.onMessageCallback = callback;
  }

  /**
   * 设置连接状态回调
   */
  setCallbacks({ onOpen, onClose, onError }) {
    this.onOpenCallback = onOpen;
    this.onCloseCallback = onClose;
    this.onErrorCallback = onError;
  }

  /**
   * 检查连接状态
   */
  isConnected() {
    return this.ws && this.ws.readyState === WebSocket.OPEN;
  }
  
  /**
   * 获取当前状态信息(用于调试)
   */
  getStatus() {
    return {
      url: this.url,
      isConnected: this.isConnected(),
      readyState: this.ws ? this.ws.readyState : null,
      retryCount: this.retryCount,
      isConnecting: this.isConnecting,
      heartAckTimeoutCount: this.heartAckTimeoutCount,
      isManualClose: this.isManualClose,
      isInternalClose: this.isInternalClose
    };
  }
}
